import { render, staticRenderFns } from "./basket-form-discount-card.vue?vue&type=template&id=115d87b4"
import script from "./basket-form-discount-card.vue?vue&type=script&lang=js"
export * from "./basket-form-discount-card.vue?vue&type=script&lang=js"
import style0 from "./basket-form-discount-card.vue?vue&type=style&index=0&id=115d87b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
